import { Drawer } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import useTopElement from "backend/hooks/model/useTopElement";
import { ITopElement } from "backend/model/model";
import clsx from "clsx";
import { t } from "i18next";
import { getKpisAndProjectsManagementHierarchyMode } from "qpr-base/configuration";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { getElementName } from "qpr-base/tplutils/utils";
import React, { FunctionComponent, useState } from "react";
import { Else, If, Then } from "react-if";
import TruncateMarkup from "react-truncate-markup";
import Category from "./SideMenuCategories";
import { MappedData as Elements, MappedData } from "./index.dto";
import { useSideMenuStyles } from "./themes";

interface SideMenuProps {
  open: boolean;
  openCategory: any;
  setSelectedElement: (element: MappedData | undefined) => void;
  setopenCategory: any;
  hierarchy: Elements[];
  topElements: ITopElement[];
}

const SideMenu: FunctionComponent<SideMenuProps> = (props) => {
  const ctx = useAppContext();

  const { data: topElement, isLoading: topElementLoading } = useTopElement(
    "L0",
    'id,name,typename,value(series="JS_ATTR",period="firstforseries",as="JS_ATTR")'
  );

  const { open, openCategory, setopenCategory } = props;

  const [lastSelectedItemName, setlastSelectedItemName] = useState<string>(
    topElement?.name || ""
  );

  const hierarchyMode = getKpisAndProjectsManagementHierarchyMode();

  const highightClass = (curCatId: string) => {
    if (openCategory && openCategory.id === curCatId) {
      return "";
    }
    if (openCategory && openCategory.id !== curCatId) {
      return "dimmed";
    }

    return "";
  };
  const classes = useSideMenuStyles({
    isRtl: ctx.rtl,
    doOpeningAnimation: openCategory === undefined,
    hierarchyMode,
  })();

  if (topElementLoading) {
    return null;
  }

  return (
    <Drawer
      variant="persistent"
      anchor={ctx.rtl ? "right" : "left"}
      open
      elevation={0}
      PaperProps={{
        variant: "outlined",
      }}
      className={clsx(classes.drawer, ctx.rtl ? "ar" : "")}
    >
      <div className={open ? classes.openMenu : classes.closedMenu}>
        <div className={openCategory ? `no-highlight` : ``}>
          <div
            aria-hidden
            className="modelBtn"
            onClick={() => {
              setopenCategory(undefined);
              props.setSelectedElement(undefined);
              setlastSelectedItemName("");
            }}
          >
            <div className="modelName">
              <h3>
                <If condition={open}>
                  <Then>
                    {topElement
                      ? getElementName(topElement, ctx.language)
                      : "Undefined"}
                  </Then>
                  <Else>
                    <TruncateMarkup lines={1}>
                      <span className={classes.closedMenuText}>
                        {lastSelectedItemName
                          ? lastSelectedItemName
                          : getElementName(topElement, ctx.language)}
                      </span>
                    </TruncateMarkup>
                  </Else>
                </If>

                <KeyboardArrowDownIcon />
              </h3>
              <div className="highlightArea">
                <div />
              </div>
            </div>
          </div>

          <div className="separator" />
        </div>
        <div className="data">
          <If condition={open}>
            <Then>
              <h6 className="subtitle">
                {t(
                  `${
                    hierarchyMode === "Perspectives"
                      ? t("configtypes.Perspectives")
                      : t("configtypes.Scorecards")
                  }`
                )}
              </h6>
            </Then>
          </If>
          {props.hierarchy.map((element) => {
            return (
              <Category
                element={element}
                key={element.id}
                topElements={props.topElements}
                hierarchyMode={hierarchyMode}
                onCategorySelected={setopenCategory}
                open={element.id === openCategory?.id}
                closedCategoryHighlightClass={highightClass(element.id)}
                onElementSelected={(element) => {
                  props.setSelectedElement(element);
                  setlastSelectedItemName(
                    getElementName(
                      { ...element, ...{ JS_ATTR: element?.translations } },
                      ctx.language
                    ) || ""
                  );
                }}
              />
            );
          })}
        </div>
      </div>
    </Drawer>
  );
};

export default React.memo(SideMenu);
